const HighlightOffOutlinedIcon = ({ className = '', style = {}, width = 16, height = 16, fill = '#CF706F' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 47 47"
      fill="none"
      className={className}
      style={style}
      width={width}
      height={height}
    >
      <path 
        d="M14.5833 34.5333L23.3333 25.7833L32.0833 34.5333L34.5333 32.0833L25.7833 23.3333L34.5333 14.5833L32.0833 12.1333L23.3333 20.8833L14.5833 12.1333L12.1333 14.5833L20.8833 23.3333L12.1333 32.0833L14.5833 34.5333ZM23.3333 46.6667C20.1444 46.6667 17.1306 46.0542 14.2917 44.8292C11.4528 43.6042 8.97361 41.9319 6.85417 39.8125C4.73472 37.6931 3.0625 35.2139 1.8375 32.375C0.6125 29.5361 0 26.5222 0 23.3333C0 20.1056 0.6125 17.0722 1.8375 14.2333C3.0625 11.3944 4.73472 8.925 6.85417 6.825C8.97361 4.725 11.4528 3.0625 14.2917 1.8375C17.1306 0.6125 20.1444 0 23.3333 0C26.5611 0 29.5944 0.6125 32.4333 1.8375C35.2722 3.0625 37.7417 4.725 39.8417 6.825C41.9417 8.925 43.6042 11.3944 44.8292 14.2333C46.0542 17.0722 46.6667 20.1056 46.6667 23.3333C46.6667 26.5222 46.0542 29.5361 44.8292 32.375C43.6042 35.2139 41.9417 37.6931 39.8417 39.8125C37.7417 41.9319 35.2722 43.6042 32.4333 44.8292C29.5944 46.0542 26.5611 46.6667 23.3333 46.6667ZM23.3333 43.1667C28.8556 43.1667 33.5417 41.2319 37.3917 37.3625C41.2417 33.4931 43.1667 28.8167 43.1667 23.3333C43.1667 17.8111 41.2417 13.125 37.3917 9.275C33.5417 5.425 28.8556 3.5 23.3333 3.5C17.85 3.5 13.1736 5.425 9.30417 9.275C5.43472 13.125 3.5 17.8111 3.5 23.3333C3.5 28.8167 5.43472 33.4931 9.30417 37.3625C13.1736 41.2319 17.85 43.1667 23.3333 43.1667Z"
        fill={fill}
      />
    </svg>
  )
}

export default HighlightOffOutlinedIcon
